export default "__VITE_ASSET__BIAAIy00__"